/**
 * 业务常量 - 对齐 PRD
 */
import { InvoiceCategory, FeeFrom } from './enums.js';
// ============ 税率（PRD 04 M5 / 05 Invoice） ============
/** 发票税率（按类别） */
export const INVOICE_TAX_RATE = {
    [InvoiceCategory.GOODS]: 0.13, // 商品票 13%
    [InvoiceCategory.SERVICE_FEE]: 0.06, // 服务费票 6%
};
// ============ 备注栏模板（双套，锁定不可改）（PRD 05 Invoice） ============
/**
 * 生成备注栏内容（锁定）。
 * 商品票：委托代销，商品所有权归委托方【工厂名称】
 * 服务费票：代销服务费
 */
export function buildInvoiceRemark(category, factoryName) {
    if (category === InvoiceCategory.GOODS) {
        if (!factoryName) {
            throw new Error('商品票备注必须提供工厂名称');
        }
        return `委托代销，商品所有权归委托方【${factoryName}】`;
    }
    return '代销服务费';
}
// ============ 分账默认规则（PRD 03 F3 / 04 M8） ============
/** 平台抽佣默认费率 2%（可配置） */
export const DEFAULT_PLATFORM_FEE_RATE = 0.02;
/** 抽佣默认来源：从工厂货款扣 */
export const DEFAULT_FEE_FROM = FeeFrom.FROM_FACTORY;
/** 银行流水备注（资金流，锁定）（PRD 01 §4.2 / 04 M4） */
export const REMARK_SERVICE_FEE = '服务费';
export const REMARK_COLLECT_PAY = '代收代付';
export const REMARK_PLATFORM_FEE = '平台服务费';
// ============ 哈希链（PRD 05 §4 / 07 §3） ============
/** 创世哈希（chain_hash(0)） */
export const GENESIS_CHAIN_HASH = '0000000000000000000000000000000000000000000000000000000000000000';
// ============ 分账触发时点（PRD 03 F3） ============
/** 确认收货后多久内触发分账（毫秒），T+1 = 24h */
export const SETTLE_DELAY_MS = 24 * 60 * 60 * 1000;
// ============ 重试策略 ============
/** 银行分账失败重试次数（PRD 03 F3） */
export const SETTLE_MAX_RETRY = 3;
/** 金额舍入精度（分，PRD 03 F3：精确到分，舍入差归平台） */
export const AMOUNT_PRECISION = 2; // decimal places
//# sourceMappingURL=constants.js.map